import React from 'react';
import { IComponentPhoto } from '../../component';

export default function useGalleryListWrapper(data?: any) {
  const { pageDetail } = window;
  let { template } = pageDetail;

  if (data) {
    template = data;
  }

  const component = (template || []).find(
    one => one.type === 'photo'
  ) as IComponentPhoto | null;
  return component;
}
